import { DOCUMENT, isPlatformBrowser, registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ApplicationRef, DestroyRef, inject, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import localeDE from '@angular/common/locales/de';
import localeFR from '@angular/common/locales/fr';
// import localeNL from '@angular/common/locales/nl';
// import localeRU from '@angular/common/locales/ru';
// import localeTR from '@angular/common/locales/tr';
import localeEN from '@angular/common/locales/en-GB';
import { LanguageService } from './translate/language.service';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/de';
// import 'moment/locale/nl';
// import 'moment/locale/ru';
import 'moment/locale/en-gb';
// import 'moment/locale/tr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import localede from '@angular/common/locales/de';
registerLocaleData(localede);
@Injectable(
    { providedIn: 'root' }
)
export class I18nService {
    data: {};
    private _currentLang: string;
    private _locales = {
        de: localeDE,
        fr: localeFR,
        // ru: localeRU,
        // nl: localeNL,
        // tr: localeTR,
        'en-GB': localeEN,
    };

    private lang$: BehaviorSubject<string>;
    destroyRef = inject(DestroyRef);

    constructor(
        private http: HttpClient,
        private ref: ApplicationRef,
        private languageService: LanguageService,
        @Inject(DOCUMENT) protected dom,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.lang$ = new BehaviorSubject('de');
        this.setLanguage(this.languageService.getLanguage('de'));
    }

    public get lang(): string {
        return this._currentLang || 'de';
    }

    public get langLong(): string {
        if (this._currentLang !== 'en-GB' && this._currentLang !== 'EN-GB') {
            return this._currentLang + '-' + this._currentLang?.toLocaleUpperCase() || 'de-DE';
        } else {
            return 'en-GB';
        }
    }

    public get langOb() {
        return this.lang$.asObservable();
    }

    public get langUp() {
        return this._currentLang?.toLocaleUpperCase() || 'DE';
    }

    setLanguage(lang): void {
        if (this._locales[lang] && this._currentLang !== lang) {
            // console.log(this._locales[lang]);
            if (lang !== 'en-GB' && lang !== 'EN-GB') {
                registerLocaleData(this._locales[lang], lang + '-' + lang.toLocaleUpperCase());
            } else {
                registerLocaleData(this._locales[lang], 'en-GB');
            }
            // console.log(lang + '-' + lang.toLocaleUpperCase())
            this._currentLang = lang;
        }
        this._currentLang = lang;
        moment.locale(this._currentLang);
        if (isPlatformBrowser(this.platformId)) {
            // this.fetch(lang); // not need we use deepl
            this.lang$.next(lang);
        }
    }

    public translate(key: string, lang?: string): string {
        lang = lang || this.lang;
        return this.data?.[key] || key;
    }

    private fetch(locale: any) {
        const langFilePath = `./assets/translation/lang-${locale}.json`;
        this.fetchLangFile(langFilePath).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((data: any) => {
            this.data = data;
            this.ref.tick();
            this.lang$.next(locale);
        })
    }

    private fetchLangFile(url): Observable<any> {
        // const baseurl = this.dom.location.protocol + '//' + this.dom.location.hostname + (this.dom.location.port ? ':' + this.dom.location.port : '') + '/';
        return this.http.get(url)
            .pipe(
                map((data: any) => (data?.data || data))
            );
    }
}
